import { SVGProps } from "react";
const TrustpilotSvg = (props: SVGProps<SVGSVGElement>) => (
  <svg width={20} height={20} viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      d="M10 14.9699L14.345 13.8691L16.1608 19.4641L10 14.9699ZM20 7.73825H12.3508L10 0.535753L7.64917 7.73825H0L6.19083 12.2024L3.84 19.4049L10.0308 14.9408L13.84 12.2024L20 7.73825Z"
      fill="#383C40"
    />
  </svg>
);
export default TrustpilotSvg;
